import { toast } from 'react-toastify';

/** Support / sidebar alerts: 4s default, pause while hovered. */
export function showSupportToast(content, options = {}) {
  return toast.info(content, {
    position: 'bottom-right',
    autoClose: 4000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    pauseOnFocusLoss: false,
    draggable: true,
    toastClassName: 'unloadin-toast custom-toast',
    bodyClassName: 'unloadin-toast-body',
    progressClassName: 'unloadin-toast-progress',
    ...options,
  });
}

/** Knowledge gap toast with icon and structured content */
export function showKnowledgeGapToast(newCount, history) {
  const content = (
    <div className="custom-toast-content knowledge-gap-toast">
      <div className="toast-icon">
        <i className="fa fa-exclamation-triangle" />
      </div>
      <div className="toast-body">
        <div className="toast-title">
          New Knowledge Gap{newCount !== 1 ? 's' : ''}
        </div>
        <div className="toast-message">
          {newCount} question{newCount !== 1 ? 's' : ''} need{newCount === 1 ? 's' : ''} review
        </div>
        <div
          className="toast-action"
          onClick={() => history.push('/app/knowledge/gaps')}
        >
          View Gaps
        </div>
      </div>
    </div>
  );

  return toast.info(content, {
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    toastClassName: 'unloadin-toast custom-toast',
    bodyClassName: 'unloadin-toast-body',
    progressClassName: 'unloadin-toast-progress',
  });
}
